import React, { useEffect, useLayoutEffect, useState } from "react";
import Modal from "./Modal";
import Confetti from "./Confetti";
import Hints from "./Hints";
import style from "./Main.module.css";

const Main = () => {
  //Making sure that assets are loaded before page is rendered
  const [img1Loaded, setImg1Loaded] = useState(false);
  const [img2Loaded, setImg2Loaded] = useState(false);
  const [img3Loaded, setImg3Loaded] = useState(false);
  const [img4Loaded, setImg4Loaded] = useState(false);
  const [img5Loaded, setImg5Loaded] = useState(false);
  const [img6Loaded, setImg6Loaded] = useState(false);
  const [img7Loaded, setImg7Loaded] = useState(false);
  const [img8Loaded, setImg8Loaded] = useState(false);
  const [img9Loaded, setImg9Loaded] = useState(false);
  const [img10Loaded, setImg10Loaded] = useState(false);
  const [loaded, setLoaded] = useState(false);
  //Number of steps left
  const [number, setNumber] = useState(5);
  //Transitions states
  const [iqosStyle, setIqosStyle] = useState(0);
  const [kitStyle, setKitStyle] = useState(0);
  const [iqosOld, setIqosOld] = useState(style.iqosOld);
  const [iqosMedium, setIqosMedium] = useState(style.iqosMedium);
  const [kitOld, setKitOld] = useState(style.kitOld);
  const [kitNew, setKitNew] = useState(style.kitNew);
  const [nameOld, setNameOld] = useState(style.nameOld);
  const [nameNew, setNameNew] = useState(style.nameNew);
  const [buttonStyle, setButtonStyle] = useState(style.button);
  const [buttonPosition, setButtonPosition] = useState(
    document.getElementById("iqosNew")?.clientTop -
      document.getElementById("iqosNew")?.clientHeight
  );
  //Hint states
  const [hint, setHint] = useState("none");
  const [deviceFounded, setDeviceFounded] = useState(false);
  const [kitFounded, setKitFounded] = useState(false);
  const [nameFounded, setNameFounded] = useState(false);
  //Modal states
  const [openModal, setOpenModal] = useState(true);
  const [modalHeader, setModalHeader] = useState(<h1>Poiščite razlike</h1>);
  const [modalText, setModalText] = useState(
    <p>
      Bodite pozorni na podrobnosti na
      <br /> zgornji sliki in poiščite 4 razlike.
      <br />
      <br />
      Kliknite na razliko in ugotovite,
      <br /> kaj se je spremenilo.
      <br />
      <br />
      <span>Srečno</span>
    </p>
  );
  const [modalBtn, setModalBtn] = useState("Začnite");
  //Confetty props
  const [confettiQuantity, setConfettiQuantity] = useState(0);

  //Activate hitn
  const handleHint = () => {
    console.log("click");
    if (!kitFounded) {
      setHint("kit");
    } else if (!nameFounded) {
      setHint("name");
    } else if (!deviceFounded) {
      setHint("device");
    } else {
      setHint("button");
    }
    setTimeout(() => {
      setHint("none");
    }, 5000);
  };

  //Close modal
  const handleClose = () => {
    if (number > 1) {
      setOpenModal(false);
      setNumber(number - 1);
    } else {
      setNumber(0);
      setOpenModal(false);
      setConfettiQuantity(1);
      const timer = setTimeout(() => {
        setModalHeader(<h1>Čestitamo!</h1>);
        setModalText(
          <p>
            Uspešno ste našli vse 4 razlike.
            <br />
            Osvojili ste <span>200</span> točk.
          </p>
        );
        setModalBtn("Prevzamite točke");

        setOpenModal(true);
        setOpenModal(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  };

  //Device change position, modal props change
  const handleIqosOld = () => {
    if (!openModal) {
      setIqosOld(style.iqosOldFade);
      setIqosMedium(style.iqosMediumUp);
      setIqosStyle(1);
      setDeviceFounded(true);
      setModalHeader(<h1>Nove barve</h1>);
      setModalText(
        <p>
          IQOS ORIGINALS DUO <br />
          je dostopen v štirih novih barvah:
          <br />
          <span>Silver, Scarlet, Slate in Turquoise</span>.
        </p>
      );
      setModalBtn("Nadaljujte");
      setTimeout(() => {
        setOpenModal(true);
      }, 2000);
    }
  };

  //Button change position, modal props change
  const handleIqosMedium = () => {
    if (!openModal && iqosStyle === 1) {
      setButtonStyle(style.buttonZoom);

      setIqosStyle(2);
      setModalHeader(<h1>Turkizni gumb</h1>);
      setModalText(
        <div>
          <img src={require("../assets/images/exp.png")} alt="exp" draggable={false} />
          <p>
            Turkizna barva gumba <br />
            dopolnjuje dizajn in poskrbi za
            <br />
            večjo opaznost.
          </p>
        </div>
      );
      setModalBtn("Nadaljujte");
      setTimeout(() => {
        setOpenModal(true);
      }, 2000);
    }
  };
  //Kit change position, modal props change
  const handleKit = () => {
    if (!openModal) {
      if (!kitFounded) {
        setKitOld(style.kitOldFade);
        setKitNew(style.kitNewUp);
        setKitStyle(1);
        setKitFounded(true);
        setModalHeader(
          <h1>
            Pripomoček za dvojno
            <br /> čiščenje
          </h1>
        );
        setModalText(
          <p>
            Pakiranje vsebuje tudi nov <br />
            pripomoček za dvojno čiščenje.
          </p>
        );
        setModalBtn("Nadaljujte");

        setTimeout(() => {
          setOpenModal(true);
        }, 2000);
      }
    }
  };

  //Name change position, props change
  const handleName = () => {
    if (!openModal) {
      if (!nameFounded) {
        setNameOld(style.nameOldFade);
        setNameNew(style.nameNewUp);

        setNameFounded(true);
        setModalHeader(<h1>Nov stil, novo ime</h1>);
        setModalText(
          <p>
            Naša najbolj dovršena IQOS
            <br />
            naprava – <span>IQOS ORIGINALS DUO</span>
            <br />
            ima novo ime in novo podobo.
          </p>
        );
        setModalBtn("Nadaljujte");
        setTimeout(() => {
          setOpenModal(true);
        }, 2000);
      }
    }
  };

  //Making sure that assets are loaded before page is rendered
  useLayoutEffect(() => {
    if (
      img1Loaded &&
      img2Loaded &&
      img3Loaded &&
      img4Loaded &&
      img5Loaded &&
      img6Loaded &&
      img7Loaded &&
      img8Loaded &&
      img9Loaded &&
      img10Loaded
    ) {
      setLoaded(true);
    }
  }, [
    img1Loaded,
    img2Loaded,
    img3Loaded,
    img4Loaded,
    img5Loaded,
    img6Loaded,
    img7Loaded,
    img8Loaded,
    img9Loaded,
    img10Loaded,
  ]);

  //Button animation
  useEffect(() => {
    const positionDown =
      document.getElementById("iqosMedium")?.offsetHeight / 1.98 +
      document.getElementById("iqosMedium")?.offsetTop;
    if (loaded) {
      setButtonPosition(positionDown);
      console.log(positionDown);
    }
    if (buttonStyle === style.buttonZoom) {
      setButtonPosition(positionDown);
    }
    window.addEventListener("resize", () => {
      setButtonPosition(positionDown);
    });
  }, [buttonPosition, buttonStyle, loaded]);

  return (
    <div className={style.main}>
      <div
        style={{
          position: "absolute",
        }}
      >
        <Confetti confettiQuantity={confettiQuantity} />
      </div>{" "}
      <Modal
        openModal={openModal}
        handleClose={handleClose}
        setOpenModal={setOpenModal}
        modalHeader={modalHeader}
        modalText={modalText}
        modalBtn={modalBtn}
        number={number}
      />
      <Hints hint={hint} />
      <div className={!loaded ? style.loading : style.loaded}></div>
      <div className={style.background}>
        <div className={style.content}>
          <img
            onLoad={() => setImg1Loaded(true)}
            draggable={false}
            src={require("../assets/images/iqosold.png")}
            alt="iqos"
            className={iqosOld}
            onPointerDown={handleIqosOld}
            id="iqosOld"
          />
          <div
            style={{
              width: document?.getElementById("iqosOld")?.offsetWidth,
              height: document?.getElementById("iqosOld")?.offsetHeight,
              position: "absolute",
              bottom: "54%",
              left: "16%",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
            >
              <div
                className={style.btn1}
                onPointerDown={handleIqosMedium}
                style={{
                  display: iqosStyle === 1 ? "block" : "none",
                }}
              ></div>
              <div
                className={style.btn3}
                onPointerDown={handleIqosOld}
                style={{
                  display: iqosStyle === 0 ? "block" : "none",
                }}
              ></div>
            </div>
          </div>
          <img
            onLoad={() => setImg2Loaded(true)}
            draggable={false}
            src={require("../assets/images/kitOld.png")}
            alt="iqos"
            className={kitOld}
            onPointerDown={handleKit}
          />

          <img
            onLoad={() => setImg3Loaded(true)}
            draggable={false}
            src={require("../assets/images/nameOld.png")}
            alt="iqos"
            className={nameOld}
            onPointerDown={handleName}
          />
        </div>
      </div>
      <div className={style.background2}>
        <div className={style.content}>
          <img
            onLoad={() => setImg5Loaded(true)}
            draggable={false}
            src={require("../assets/images/iqosNew.png")}
            alt="iqos"
            className={style.iqosNew}
            onPointerDown={handleIqosMedium}
            id="iqosNew"
          />
          <img
            onLoad={() => setImg6Loaded(true)}
            draggable={false}
            src={require("../assets/images/iqosMedium.png")}
            alt="iqos"
            className={iqosMedium}
            id="iqosMedium"
          />
          <img
            onLoad={() => setImg4Loaded(true)}
            draggable={false}
            src={require("../assets/images/button.png")}
            alt="button"
            className={buttonStyle}
            style={{
              top: buttonPosition,
            }}
          />

          <div
            style={{
              width: document?.getElementById("iqosOld")?.offsetWidth,
              height: document?.getElementById("iqosOld")?.offsetHeight,
              position: "absolute",
              bottom: "4%",
              left: "16%",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
            >
              {" "}
              <div
                className={style.btn1}
                onPointerDown={handleIqosMedium}
                style={{
                  display: iqosStyle === 1 ? "block" : "none",
                }}
              ></div>
              <div
                className={style.btn3}
                onPointerDown={handleIqosOld}
                style={{
                  display: iqosStyle === 0 ? "block" : "none",
                }}
              ></div>
            </div>
          </div>
          <img
            onLoad={() => setImg7Loaded(true)}
            draggable={false}
            src={require("../assets/images/kitNew.png")}
            alt="iqos"
            className={style.kitNew}
          />
          <img
            onLoad={() => setImg8Loaded(true)}
            draggable={false}
            src={require("../assets/images/kitNew.png")}
            alt="iqos"
            className={kitNew}
          />
          <img
            onLoad={() => setImg9Loaded(true)}
            draggable={false}
            src={require("../assets/images/nameNew.png")}
            alt="iqos"
            className={style.nameNew}
          />
          <img
            onLoad={() => setImg10Loaded(true)}
            draggable={false}
            src={require("../assets/images/nameNew.png")}
            alt="iqos"
            className={nameNew}
            onPointerDown={handleName}
          />
        </div>

        <div className={style.buttons}>
          <div
            className={style.btn4}
            onPointerDown={handleIqosOld}
            style={{
              display: iqosStyle === 0 ? "block" : "none",
            }}
          ></div>
          <div
            className={style.btn5}
            onPointerDown={handleKit}
            style={{
              display: kitStyle === 0 ? "block" : "none",
            }}
          ></div>
          <div
            className={style.btn6}
            onPointerDown={handleKit}
            style={{
              display: kitStyle === 0 ? "block" : "none",
            }}
          ></div>
          <div
            className={style.btn7}
            onPointerDown={handleKit}
            style={{
              display: kitStyle === 0 ? "block" : "none",
            }}
          ></div>
          <div
            className={style.btn8}
            onPointerDown={handleKit}
            style={{
              display: kitStyle === 0 ? "block" : "none",
            }}
          ></div>
        </div>
      </div>
      <button className={style.eclipse} onClick={handleHint}>
        <div>
          <p>{number === 5 ? 4 : number}</p>
        </div>
      </button>
    </div>
  );
};

export default Main;
